const handlePaywall = () => {
    const paywall = document.getElementsByClassName('js-paywall');

    if (typeof rmgPaywall === 'undefined') {
        return false;
    }

    return rmgPaywall && window.rmgArticleData && paywall !== 'undefined' && paywall.length;
};

document.addEventListener("DOMContentLoaded", () => {
    if (handlePaywall()) {
        rmgPaywall.checkArticle(window.rmgArticleData.articleId, {}, function (access, context) {
            if (!access) {
                return;
            }

            jQuery.ajax( {
                url      : themevars.ajaxurl,
                data     : {
                    action: 'get_prem_content',
                    post_id: window.rmgArticleData.articleId,
                    nonce: themevars.con_nonce
                },
                type     : 'POST',
                dataType : 'json'
            } ).done( function ( response ) {
    
                if (true !== response.success) {
                    return;
                }
                
                let contentContainers = document.getElementsByClassName('single-content');
                let contentContainer = contentContainers[0];

                contentContainer.innerHTML = response.data.content;
            });
        });
    }
});
